/**
 * 新的 java 活动服务调用
 * 在具体活动里单独引入
 */
import axios from 'axios';
import urlConfig from '@/config';
import HllUI from '@/libs/hll-m-ui';
import { UNIQUE_ID } from '@/components/js/watchDog/uniqueId';
import { getAccessTokenByToken } from '@/components/mixins/tokenIn';
import {
  callApp,
  getAccessToken,
  parseUserType,
  isJdMiniProgram,
  parseBusinessLine,
  isXlAppByClientType,
  isXlMiniProgram,
  type,
  isCompanyApp,
  isHllApp,
  isWxMiniProgram,
  isAlipayMiniUa,
  isBaiduBoxUa
} from '@/utils';

import { XL_HOST } from '@/utils/constants';

const reloadByTokenInStatus = status => {
  let reloaded = sessionStorage.getItem('reloaded'); //防止重复刷新
  if (!reloaded && status) {
    sessionStorage.setItem('reloaded', 1);
    location.reload();
    return true;
  }
};

function createInstance(axios, router, store) {
  //创建axios实例
  //请求头动态配置
  const instance = axios.create({
    baseURL: urlConfig.secondBaseUrl,
    timeout: 20000, // 超时
    headers: {
      'Content-Type': 'application/json'
    },
    withCredentials: true
  });

  // 添加请求拦截器
  instance.interceptors.request.use(
    async function(config) {
      // for test.
      const { hostInfo, accountType } = store.state.global || {};
      if (hostInfo && hostInfo[XL_HOST]) {
        config.baseURL = hostInfo[XL_HOST];
      }
      config.headers = {
        ...config.headers,
        'X-User-Type': parseUserType(store.state.global.env),
        Authorization: getAccessToken({ accountType }),
        'X-User-BusinessLine': parseBusinessLine(accountType),
        'X-Unique-Id': UNIQUE_ID
      };
      return config;
    },
    function(error) {
      return Promise.reject(error);
    }
  );

  // 添加响应拦截器
  instance.interceptors.response.use(
    async function(response) {
      // 对响应数据做点什么
      let res = response.data;
      // return response
      if (type(res) != 'object') {
        HllUI.$hll.toast('网络错误');
        return res;
      }
      if ('ret' in res) {
        //对内部请求做判断处理
        console.log(res, 'ret=====>request.js', isHllApp());

        if (res.ret == 0) {
          return res.data;

          //USER_NOT_LOGIN(11013, "user.not.login", "用户未登录") 废弃(设计给 java 登录服务用的)
          //DRIVER_NOT_LOGIN(11014, "driver.not.login", "司机未登录") 废弃
          //USER_NOT_LOGIN(11015, "user.not.login", "用户未登录")
          //DRIVER_NOT_LOGIN(11016, "driver.not.login", "司机未登录，用户司机端串号也是这种情况")
        } else if (res.ret == 11015 || res.ret == 11016) {
          // HllUI.$hll.toast(res.msg);
          if (isXlMiniProgram()) {
            // 小拉 微信小程序
            let globalState = (store.state || {}).global || {};
            let loginStatus = await getAccessTokenByToken(
              globalState.appToken,
              globalState.env,
              { accountType: globalState.accountType }
            ); //重新调用tokenIn接口,返回tokenIn状态
            reloadByTokenInStatus(loginStatus); //根据tokenIN状态进行重新加载
            // 如果 reload 了页面，下面 js 也不会执行
            return wx.miniProgram.reLaunch({
              url: `/pages/index/index?webview=${encodeURIComponent(
                location.href
              )}`
            });
          } else if (isWxMiniProgram()) {
            wx.miniProgram.navigateTo({
              url: '/pages/login/index'
            });
          } else {
            if (isHllApp()) {
              //App内
              let globalState = (store.state || {}).global || {};
              let loginStatus = await getAccessTokenByToken(
                globalState.appToken,
                globalState.env,
                { accountType: globalState.accountType }
              ); //重新调用tokenIn接口,返回tokenIn状态
              console.log(loginStatus, 'loginStatus ---->');
              const isReloaded = reloadByTokenInStatus(loginStatus); //根据tokenIN状态进行重新加载
              if (isReloaded) {
                return;
              }
              if (isXlAppByClientType()) {
                // 小拉 APP 的流程
                // 小拉 app
                return my.reLaunch({
                  url: `/pages/index/index?webview=${encodeURIComponent(
                    location.href
                  )}`
                });
              } else {
                let args = isCompanyApp()
                  ? {
                      action: 'openNativePage',
                      type: 1
                    }
                  : {
                      action: 'login'
                    };
                callApp(JSON.stringify(args));
              }
            } else if (isJdMiniProgram()) {
              /* eslint-disable  */
              // 京东小程序
              return jd.miniProgram.navigateTo({
                url: '/pages/login/index'
              });
            } else if (isAlipayMiniUa()) {
              my.navigateTo({
                url: '/pages/login/index'
              });
            } else if (isBaiduBoxUa()) {
              console.log('axios: swan is', typeof swan, swan);
              swan.webView.navigateTo({
                url: '/pages/login/index'
              });
            } else {
              router.options.routes.some(e => e.path == '/login') &&
                router.replace('/login'); //路由中存在login时跳转至login
            }
          }
          return Promise.reject(res);
        } else {
          // 如果是命中风控，不显示 toast
          const isRiskCode =
            [11004, 11017, 11018, 11019, 11038, 11039, 11020].indexOf(
              res.ret
            ) !== -1;
          const needDisplayMsg = !isRiskCode;

          if (res.msg && needDisplayMsg) {
            HllUI.$hll.toast(res.msg);
          }
          if (response.config) {
            // 用于日志
            const config = response.config;
            res._url = config.baseURL + config.url;
            res._reqData = config.data;
          }
          return Promise.reject(res);
        }
      } else {
        //外部接口
        return res;
      }
    },
    function (error) {
      if (error) {
        if (!error.msg) {
          error.msg = error.message || '网络错误';
        }
      }
      return Promise.reject(error);
    }
  );
  return instance;
}

let installedResolve = null;

//初始化
function install(Vue, router, store) {
  let instance = createInstance(axios, router, store);

  //添加全局方法
  Vue.prototype.$request = instance;

  installedResolve && installedResolve(instance);
}

function installed() {
  return new Promise(resolve => {
    installedResolve = resolve;
  });
}

export default {
  install,
  // 用于获取 install 后的实例
  installedPromise: installed()
};
